/**
 * Español (Chile). Source of truth para keys. Cualquier key que falte en
 * otro locale caerá a esta versión.
 */

export const es: Record<string, string> = {
  'brand.name': 'Dr Newen IA',
  'brand.subtitle': 'Clinical Triage System',
  'brand.tagline': 'Entrená tu criterio clínico con casos reales, IA y hand tracking.',

  'auth.welcome': 'Bienvenido',
  'auth.login': 'Iniciar sesión',
  'auth.register': 'Crear cuenta',
  'auth.email': 'Email',
  'auth.password': 'Contraseña',
  'auth.name': 'Nombre',
  'auth.role': 'Rol',
  'auth.role.student': 'Alumno',
  'auth.role.teacher': 'Profesor',
  'auth.enter': 'Entrar',
  'auth.create': 'Crear cuenta',
  'auth.disclaimer': 'Solo para fines educativos. No reemplaza criterio médico.',
  'auth.password.min': 'Mínimo 8 caracteres',

  'sidebar.cases.title': 'Casos de prueba',
  'sidebar.session.title': 'Sesión clínica',
  'sidebar.tools.title': 'Herramientas',
  'sidebar.camera.title': 'Cámara',
  'sidebar.gestures.title': 'Gestos',
  'sidebar.shortcuts.title': 'Atajos',
  'sidebar.logout': 'Cerrar sesión',
  'sidebar.myProgress': 'Mi progreso',

  'help.title': 'Ayuda',
  'help.subtitle': 'Referencia rápida del simulador.',
  'help.tab.gestures': 'Gestos',
  'help.tab.mouse': 'Mouse',
  'help.tab.keyboard': 'Atajos',
  'help.tab.exams': 'Exámenes',
  'help.tab.patterns': 'Patrones',
  'help.tab.triage': 'Triage',

  'common.close': 'Cerrar',
  'common.cancel': 'Cancelar',
  'common.save': 'Guardar',
  'common.loading': 'Cargando…',
  'common.error': 'Error',
};
